const foodConcessionsData = {
  id: "foodConcessions",
  name: "Food & Concessions",

  values: [
    {
      type: "ALL",
      totalSlots: "400",
      available: "670",
      occupied: "335",
      occupiedPercentage: "47",
      iconsInfo: [
        {
          type: "VIP",

          total: "130",

          available: "150",

          occupied: "130",

          icon: "",
        },
        {
          type: "VIP",

          total: "75",

          available: "150",

          occupied: "75",

          icon: "",
        },
        {
          type: "VIP",

          total: "65",

          available: "150",

          occupied: "65",

          icon: "",
        },
        {
          type: "VIP",

          total: "$123",

          available: "150",

          occupied: "$123",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
      ],
      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 99.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 100.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 98.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 98.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 96.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 90.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 98.0,
            },
            {
              node: "2022-10-11T11:00:00",
              count: 99.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 100.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 98.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 98.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 96.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 90.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 98.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-04-11T11:00:00",
              count: 100.0,
            },
            {
              node: "2022-05-11T12:00:00",
              count: 30.0,
            },
            {
              node: "2022-06-11T13:00:00",
              count: 77.0,
            },
            {
              node: "2022-07-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-08-11T15:00:00",
              count: 37.0,
            },
            {
              node: "2022-09-11T16:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 67.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2023-05-11T18:00:00",
              count: 97.0,
            },
            {
              node: "2023-06-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2023-07-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2023-05-11T18:00:00",
              count: 97.0,
            },
            {
              node: "2023-06-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2023-07-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2023-05-11T18:00:00",
              count: 97.0,
            },
            {
              node: "2023-06-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2023-07-11T21:00:00",
              count: 47.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 27.0,
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "05",
          list: [
            {
              category: "foodConcessions",
              id: "evt-01",
              title: "Restaurant Is Under Maintenance",
              restauratName: "Pat LaFrieda's",
              timeStamp: "12-15-2022 | 09:00 AM",
              img: "",
              video: "",
              location: {
                lat: 40.758262252016614,
                lng: -73.84503880243874,
              },
            },
            {
              category: "foodConcessions",
              id: "evt-02",
              title: "Restaurant Is Under Maintenance",
              restauratName: "The Porsche Club",
              timeStamp: "12-15-2022 | 09:00 AM",
              img: "",
              video: "",
              location: {
                lat: 40.75828389919421,
                lng: -73.84535173355135,
              },
            },
            {
              category: "foodConcessions",
              id: "evt-03",
              title: "Restroom Cleaning Inprogress",
              restauratName: "The Porsche Club",
              timeStamp: "12-15-2022 | 09:00 AM",
              img: "",
              video: "",
              location: {
                lat: 40.757129089463184,
                lng: -73.84687907688999,
              },
            },
            {
              category: "foodConcessions",
              id: "evt-04",
              title: "Entrance Gate Opened",
              restauratName: "Pat LaFrieda's",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "Bay - B1",
              parkingLot: "Ground Floor",
              img: "",
              video: "",
              location: {
                lat: 40.75757469615152,

                lng: -73.8450628377235,
              },
            },
            {
              category: "foodConcessions",
              id: "evt-05",
              title: "Restaurant Is Operational Now",
              restauratName: "The Porsche Club",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "2nd Floor",
              parkingLot: "Cafeteria",
              img: "",
              video: "",
              location: {
                lat: 40.75763316274552,
                lng: -73.84484348051029,
              },
            },
          ],
        },
        incidents: {
          totalCount: "07",
          list: [
            {
              category: "foodConcessions",
              id: "ict-01",
              title: "Low Inventory Level",
              restauratName: "Pat LaFrieda's",
              inventoryLevel: "10%",
              timeStamp: "12-15-2022 | 09:00 AM",

              img: "",
              video: "",
              location: {
                lat: 40.756996278330654,
                lng: -73.84445184415326,
              },
            },
            {
              category: "foodConcessions",
              id: "ict-02",
              title: "Order Delayed",
              restauratName: "Pat LaFrieda's",
              orderNumber: "#123",
              delayedTime: "15 mins",
              timeStamp: "12-15-2022 | 09:00 AM",

              img: "",
              video: "",
              location: {
                lat: 40.7571482748172,
                lng: -73.84681583272432,
              },
            },
            {
              category: "foodConcessions",
              id: "ict-03",
              title: "Pending Order",
              restauratName: "Pat LaFrieda's",
              pendingOrders: "05",
              pendingTime: "15 mins",
              timeStamp: "12-15-2022 | 09:00 AM",

              img: "",
              video: "",
              location: {
                lat: 40.7571482748172,
                lng: -73.84681583272432,
              },
            },
            {
              category: "foodConcessions",
              id: "ict-04",
              title: "Crowd Forming",
              restauratName: "Pat LaFrieda's",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "Restaurant Entrance",
              img: "",
              video: "",
              location: {
                lat: 40.756707363728836,

                lng: -73.84806674636111,
              },
            },
            {
              category: "foodConcessions",
              id: "ict-05",
              title: "Unauthorized Access",
              restauratName: "Shake Shack Hamburgers",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "Kitchen",
              img: "",
              video: "",
              location: {
                lat: 40.75675206167507,

                lng: -73.84716318457585,
              },
            },
            {
              category: "foodConcessions",
              id: "ict-06",
              title: "Restaurant Open",
              restauratName: "The Porsche Club",
              timeStamp: "12-15-2022 | 09:00 AM",
              img: "",
              video: "",
              location: {
                lat: 40.757635398864174,
                lng: -73.84664658572008,
              },
            },
            {
              category: "foodConcessions",
              id: "ict-07",
              title: "Crowd Forming",
              restauratName: "The Porsche Club",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "Restaurant Entrance",
              img: "",
              video: "",
              location: {
                lat: 40.757129089463184,
                lng: -73.84687907688999,
              },
            },
          ],
        },

        operationalAlerts: {
          totalCount: "04",
          list: [
            {
              category: "foodConcessions",
              id: "opr-01",
              title: "Operational Now",
              restauratName: "Pat LaFrieda's",
              timeStamp: "12-15-2022 | 09:00 AM",
              img: "",
              video: "",
              location: {
                lat: 40.75756638098499,
                lng: -73.84735433852819,
              },
            },
            {
              category: "foodConcessions",
              id: "opr-02",
              title: "Not Operational",
              restauratName: "Pat LaFrieda's",
              timeStamp: "12-15-2022 | 09:00 AM",
              img: "",
              video: "",
              location: {
                lat: 40.7571482748172,
                lng: -73.84681583272432,
              },
            },
            {
              category: "foodConcessions",
              id: "opr-03",
              title: "Smoke Detected",
              restauratName: "Shake Shack Hamburgers",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "Restaurant Exit Gate",
              img: "",
              video: "",
              location: {
                lat: 40.7571482748172,
                lng: -73.84681583272432,
              },
            },
            {
              category: "foodConcessions",
              id: "opr-04",
              title: "Camera Not Functional",
              restauratName: "Shake Shack Hamburgers",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "Restaurant Entrance",
              img: "",
              video: "",
              location: {
                lat: 40.75739954092732,
                lng: -73.84686247037784,
              },
            },
          ],
        },
      },
    },
    {
      type: "Tab2",
      totalSlots: "400",
      available: "670",
      occupied: "335",
      occupiedPercentage: "50",
      iconsInfo: [
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
      ],
      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 99.0,
            },
            {
              node: "2022-11-11T12:00:00",
              count: 57.0,
            },
            {
              node: "2022-12-11T13:00:00",
              count: 77.0,
            },
            {
              node: "2023-01-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2023-02-11T15:00:00",
              count: 37.0,
            },
            {
              node: "2023-03-11T16:00:00",
              count: 27.0,
            },
            {
              node: "2023-04-11T17:00:00",
              count: 67.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-01-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 97.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-01-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 97.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-01-11T11:00:00",
              count: 77.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 27.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 17.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 97.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 117.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 227.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 287.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 277.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "02",
          list: [
            {
              category: "foodConcessions",
              id: "evt-01",
              title: "Restaurant Is Under Maintenance",
              restauratName: "Pat LaFrieda's",
              timeStamp: "12-15-2022 | 09:00 AM",
              img: "",
              video: "",
              location: {
                lat: 40.758262252016614,
                lng: -73.84503880243874,
              },
            },
            {
              category: "foodConcessions",
              id: "evt-02",
              title: "Restaurant Is Under Maintenance",
              restauratName: "The Porsche Club",
              timeStamp: "12-15-2022 | 09:00 AM",

              img: "",
              video: "",
              location: {
                lat: 40.75828389919421,
                lng: -73.84535173355135,
              },
            },
          ],
        },
        incidents: {
          totalCount: "06",
          list: [
            {
              category: "foodConcessions",
              id: "ict-21",
              title: "Low Inventory Level",
              restauratName: "Pat LaFrieda's",
              inventoryLevel: "10%",
              timeStamp: "12-15-2022 | 09:00 AM",
              img: "",
              video: "",
              location: {
                lat: 40.756996278330654,
                lng: -73.84445184415326,
              },
            },
            {
              category: "foodConcessions",
              id: "ict-22",
              title: "Order Delayed",
              restauratName: "Pat LaFrieda's",
              orderNumber: "#123",
              delayedTime: "15 mins",
              timeStamp: "12-15-2022 | 09:00 AM",
              img: "",
              video: "",
              location: {
                lat: 40.7571482748172,
                lng: -73.84681583272432,
              },
            },
            {
              category: "foodConcessions",
              id: "ict-23",
              title: "Pending Order",
              restauratName: "Pat LaFrieda's",
              pendingOrders: "05",
              pendingTime: "15 mins",
              timeStamp: "12-15-2022 | 09:00 AM",

              img: "",
              video: "",
              location: {
                lat: 40.7571482748172,
                lng: -73.84681583272432,
              },
            },
            {
              category: "foodConcessions",
              id: "ict-24",
              title: "Crowd Forming",
              restauratName: "Pat LaFrieda's",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "Restaurant Entrance",
              img: "",
              video: "",
              location: {
                lat: 40.756707363728836,

                lng: -73.84806674636111,
              },
            },
            {
              category: "foodConcessions",
              id: "ict-25",
              title: "Unauthorized Access",
              restauratName: "Shake Shack Hamburgers",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "Kitchen",
              img: "",
              video: "",
              location: {
                lat: 40.75675206167507,

                lng: -73.84716318457585,
              },
            },
            {
              category: "foodConcessions",
              id: "ict-26",
              title: "Restaurant Closed",
              restauratName: "The Porsche Club",
              timeStamp: "12-15-2022 | 09:00 AM",
              img: "",
              video: "",
              location: {
                lat: 40.757635398864174,
                lng: -73.84664658572008,
              },
            },
          ],
        },

        operationalAlerts: {
          totalCount: "03",
          list: [
            {
              category: "foodConcessions",
              id: "opr-21",
              title: "Operational Now",
              restauratName: "Pat LaFrieda's",
              timeStamp: "12-15-2022 | 09:00 AM",
              img: "",
              video: "",
              location: {
                lat: 40.75756638098499,
                lng: -73.84735433852819,
              },
            },
            {
              category: "foodConcessions",
              id: "opr-22",
              title: "Not Operational",
              restauratName: "Pat LaFrieda's",
              timeStamp: "12-15-2022 | 09:00 AM",
              img: "",
              video: "",
              location: {
                lat: 40.7571482748172,
                lng: -73.84681583272432,
              },
            },
            {
              category: "foodConcessions",
              id: "opr-23",
              title: "Smoke Detected",
              restauratName: "Shake Shack Hamburgers",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "Restaurant Exit Gate",
              img: "",
              video: "",
              location: {
                lat: 40.7571482748172,
                lng: -73.84681583272432,
              },
            },
          ],
        },
      },
    },
    {
      type: "Tab3",
      totalSlots: "400",
      available: "670",
      occupied: "335",
      occupiedPercentage: "50",
      iconsInfo: [
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
      ],
      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-02-11T11:00:00",
              count: 109.0,
            },
            {
              node: "2022-03-11T12:00:00",
              count: 157.0,
            },
            {
              node: "2022-04-11T13:00:00",
              count: 177.0,
            },
            {
              node: "2022-05-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-06-11T15:00:00",
              count: 137.0,
            },
            {
              node: "2022-07-11T16:00:00",
              count: 227.0,
            },
            {
              node: "2022-08-11T17:00:00",
              count: 267.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-02-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-03-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-04-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-05-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-06-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-07-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-08-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-09-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-11-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-12-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-02-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-03-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-04-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-05-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-06-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-07-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-08-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-09-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-11-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-12-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-02-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-03-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-04-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-05-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-06-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-07-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-08-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-09-11T18:00:00",
              count: 297.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 117.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 227.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 287.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 277.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "01",
          list: [
            {
              category: "foodConcessions",
              id: "evt-33",
              title: "Restroom Cleaning Inprogress",
              restauratName: "The Porsche Club",
              timeStamp: "12-15-2022 | 09:00 AM",
              img: "",
              video: "",
              location: {
                lat: 40.757829089463184,
                lng: -73.84687907688999,
              },
            },
          ],
        },
        incidents: {
          totalCount: "01",
          list: [
            {
              category: "foodConcessions",
              id: "ict-37",
              title: "Crowd Forming",
              restauratName: "The Porsche Club",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "Restaurant Entrance",
              img: "",
              video: "",
              location: {
                lat: 40.757329089463184,
                lng: -73.84687907688999,
              },
            },
          ],
        },
        operationalAlerts: {
          totalCount: "01",
          list: [
            {
              category: "foodConcessions",
              id: "opr-33",
              title: "Smoke Detected",
              restauratName: "Shake Shack Hamburgers",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "Restaurant Exit Gate",
              img: "",
              video: "",
              location: {
                lat: 40.7571482748172,
                lng: -73.84681583272432,
              },
            },
          ],
        },
      },
    },

    {
      type: "Tab4",
      totalSlots: "400",
      available: "670",
      occupied: "335",
      occupiedPercentage: "50",
      iconsInfo: [
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
      ],
      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-03-11T11:00:00",
              count: 109.0,
            },
            {
              node: "2022-04-11T12:00:00",
              count: 157.0,
            },
            {
              node: "2022-05-11T13:00:00",
              count: 177.0,
            },
            {
              node: "2022-06-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T15:00:00",
              count: 137.0,
            },
            {
              node: "2022-08-11T16:00:00",
              count: 227.0,
            },
            {
              node: "2022-09-11T17:00:00",
              count: 267.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-03-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-04-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-05-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-06-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-08-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-09-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-11-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-12-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-01-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-03-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-04-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-05-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-06-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-08-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-09-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-11-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-12-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-01-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-11-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-12-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-01-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-11-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-12-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-01-11T22:00:00",
              count: 177.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 117.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 227.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 287.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 277.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "01",
          list: [
            {
              category: "foodConcessions",
              id: "evt-44",
              title: "Entrance Gate Opened",
              restauratName: "Pat LaFrieda's",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "Bay - B1",
              parkingLot: "Ground Floor",
              img: "",
              video: "",
              location: {
                lat: 40.75757469615152,

                lng: -73.8450628377235,
              },
            },
          ],
        },
        incidents: {
          totalCount: "01",
          list: [
            {
              category: "foodConcessions",
              id: "ict-41",
              title: "Crowd Forming",
              restauratName: "Pat LaFrieda's",
              //inventoryLevel: "10%",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "Restaurant Entrance",
              img: "",
              video: "",
              location: {
                lat: 40.75806638098499,
                lng: -73.84735433852819,
              },
            },
          ],
        },

        operationalAlerts: {
          totalCount: "01",
          list: [
            {
              category: "foodConcessions",
              id: "opr-411",
              title: "Entrance Gate Closed",
              restauratName: "Pat LaFrieda's",
              //inventoryLevel: "10%",
              spot: " Restaurant Entrance",
              timeStamp: "12-15-2022 | 09:00 AM",

              img: "",
              video: "",
              location: {
                lat: 40.75756638098499,
                lng: -73.84735433852819,
              },
            },
          ],
        },
      },
    },
    {
      type: "Tab5",
      totalSlots: "400",
      available: "670",
      occupied: "335",
      occupiedPercentage: "50",
      iconsInfo: [
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
        {
          type: "VIP",

          total: "100",

          available: "150",

          occupied: "100",

          icon: "",
        },
      ],
      analytics: {
        day: {
          analytics: [
            {
              node: "2022-10-11T11:00:00",
              count: 17.0,
            },
            {
              node: "2022-10-11T12:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T13:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T14:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T15:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 67.0,
            },
            {
              node: "2022-10-11T17:00:00",
              count: 27.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
            {
              node: "2022-10-11T19:00:00",
              count: 87.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 47.0,
            },
            {
              node: "2022-10-11T22:00:00",
              count: 77.0,
            },
            {
              node: "2022-10-11T18:00:00",
              count: 57.0,
            },
          ],
        },
        weekly: {
          analytics: [
            {
              node: "2022-01-11T11:00:00",
              count: 109.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 157.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 177.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 137.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 227.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 267.0,
            },
          ],
        },
        monthly: {
          analytics: [
            {
              node: "2022-01-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-01-11T11:00:00",
              count: 107.0,
            },
            {
              node: "2022-02-11T12:00:00",
              count: 127.0,
            },
            {
              node: "2022-03-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-04-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-05-11T15:00:00",
              count: 287.0,
            },
            {
              node: "2022-06-11T16:00:00",
              count: 217.0,
            },
            {
              node: "2022-07-11T17:00:00",
              count: 127.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 177.0,
            },
            {
              node: "2022-08-11T18:00:00",
              count: 297.0,
            },
            {
              node: "2022-09-11T19:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2022-11-11T22:00:00",
              count: 177.0,
            },
          ],
        },
        yearly: {
          analytics: [
            {
              node: "2022-05-11T11:00:00",
              count: 117.0,
            },
            {
              node: "2022-06-11T12:00:00",
              count: 147.0,
            },
            {
              node: "2022-07-11T13:00:00",
              count: 157.0,
            },
            {
              node: "2022-08-11T14:00:00",
              count: 147.0,
            },
            {
              node: "2022-09-11T15:00:00",
              count: 187.0,
            },
            {
              node: "2022-10-11T16:00:00",
              count: 267.0,
            },
            {
              node: "2022-11-11T17:00:00",
              count: 227.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
            {
              node: "2023-01-11T19:00:00",
              count: 287.0,
            },
            {
              node: "2023-02-11T21:00:00",
              count: 247.0,
            },
            {
              node: "2023-03-11T22:00:00",
              count: 277.0,
            },
            {
              node: "2022-12-11T18:00:00",
              count: 257.0,
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "01",
          list: [
            {
              category: "foodConcessions",
              id: "evt-55",
              title: "Restaurant Is Operational Now",
              restauratName: "The Porsche Club",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "2nd Floor",
              parkingLot: "Cafeteria",
              img: "",
              video: "",
              location: {
                lat: 40.75763316274552,
                lng: -73.84484348051029,
              },
            },
          ],
        },
        incidents: {
          totalCount: "01",
          list: [
            {
              category: "foodConcessions",
              id: "ict-511",
              title: "Crowd Forming",
              restauratName: "Pat LaFrieda's",
              //inventoryLevel: "10%",
              timeStamp: "12-15-2022 | 09:00 AM",
              spot: "Restaurant Entrance",
              img: "",
              video: "",
              location: {
                lat: 40.75780638098499,
                lng: -73.84736433852819,
              },
            },
          ],
        },

        operationalAlerts: {
          totalCount: "01",
          list: [
            {
              category: "foodConcessions",
              id: "opr-5111",
              title: "Restaurants Open",
              restauratName: "Pat LaFrieda's",
              //inventoryLevel: "10%",
              timeStamp: "12-15-2022 | 09:00 AM",
              img: "",
              video: "",
              location: {
                lat: 40.75756638098499,
                lng: -73.84735433852819,
              },
            },
          ],
        },
      },
    },
  ],
};
export default foodConcessionsData;
